exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorText{\r\n\tfont-size: 12px;\r\n\tmargin-bottom: 1px;\r\n\tcolor: #a94442;\r\n}\r\n.form-panel{\r\n\tmargin-top: 11px;\r\n\tpadding: 15px;\r\n\tbackground-color: rgba(240,240,240, .85);\r\n\tmin-height: 88vh;\r\n\ttext-align: center;\r\n}\r\n.titletext{\r\n\tfont-size: 24px;\r\n\tmargin-top: 2px;\r\n\tmargin-bottom:1px;\r\n}\r\n.main-form-body{\r\n\ttext-align: left;\r\n}\r\n.form-group{\r\n\tmargin-bottom: 0px;\r\n}\r\n.formLabel{\r\n\tmargin-bottom:0px;\r\n}\r\n.submitButton{\r\n\tmargin-top: 3px;\r\n\twidth: 100px;\r\n\tborder-color: rgb(220,30,0);\r\n\tbackground-color: rgb(255,63,0);\r\n}\r\n.submitButton:active{\r\n\tborder-color: rgb(180,15,0);\r\n\tbackground-color: rgb(220,30,0);\r\n}\r\n.submitButton:disabled{\r\n\tborder-color: rgb(180,15,0);\r\n\tbackground-color: rgb(255,90,45);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/createprofile/createprofile.component.css
// module id = ../../../../../src/app/createprofile/createprofile.component.css
// module chunks = main